import { IsNotEmpty, IsArray, IsString, MinLength, MaxLength, IsISO8601, IsInt, IsOptional } from 'class-validator';

export class CalendarEventSearchDTO {

    @IsNotEmpty()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    calendars: Array<string>;

    @IsNotEmpty()
    @IsISO8601()
    from: string;

    @IsNotEmpty()
    @IsISO8601()
    to: string;

    @IsNotEmpty()
    @IsArray()
    @IsInt({
        each: true
    })
    types: Array<number>;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    categories: Array<string>;

    @IsOptional()
    @IsString()
    @MaxLength(50)
    title: string;

}
